import React from 'react'

export default function TooltipGraficoPizza({
  active,
  payload,
  arrDados,
  isTecnologia = false,
  graficoTotalTecnologias,
  totalSimcards
}) {
  let percentual = null
  const total = isTecnologia ? graficoTotalTecnologias || 0 : totalSimcards

  if (total === 0) percentual = 100
  else if (active && payload !== null && payload?.length) {
    percentual = `${parseFloat((payload[0].payload.value / total) * 100).toFixed(2)}`
  } else if (!arrDados?.length) percentual = 0
  if (percentual === null) return null

  return (
    <div className="container-tooltip-grafico-pizza">
      <p className="label-tooltip-grafico-pizza">{percentual}%</p>
    </div>
  )
}

